// extracted by mini-css-extract-plugin
export default {"container":"Field_container__mmMkT","title":"Field_title__b7ax8","value":"Field_value__pn+Ez"};